/* FB HEADER — sticky-state, skjul ved scroll ned, mobil-drawer.
   Custom element saa theme editor kan reloade sektionen uden dubletter. */
(function () {
  'use strict';

  if (customElements.get('fb-header')) return;

  var SCROLL_TRIGGER = 8; // px foer vi kalder den "stuck"
  var HIDE_AFTER = 140; // px foer vi begynder at skjule

  class FbHeader extends HTMLElement {
    connectedCallback() {
      this.sticky = this.dataset.sticky === 'true';
      this.hideOnScroll = this.dataset.hideOnScroll === 'true';
      this.lastY = window.scrollY;
      this.ticking = false;

      this.onScroll = this.onScroll.bind(this);
      window.addEventListener('scroll', this.onScroll, { passive: true });
      this.update();

      this.setupDrawer();
      this.setupCartCount();
    }

    disconnectedCallback() {
      window.removeEventListener('scroll', this.onScroll);
      document.removeEventListener('keydown', this.onKeydown);
    }

    onScroll() {
      if (this.ticking) return;
      this.ticking = true;
      window.requestAnimationFrame(
        function () {
          this.update();
          this.ticking = false;
        }.bind(this)
      );
    }

    update() {
      var y = window.scrollY;

      this.classList.toggle('is-stuck', y > SCROLL_TRIGGER);

      if (this.sticky && this.hideOnScroll) {
        var goingDown = y > this.lastY;
        // Skjul aldrig mens drawer er aaben
        var drawerOpen = this.drawer && this.drawer.classList.contains('is-open');
        this.classList.toggle('is-hidden', goingDown && y > HIDE_AFTER && !drawerOpen);
      }

      this.lastY = y;
    }

    /* ------------------------------- Drawer ------------------------------ */
    setupDrawer() {
      this.drawer = this.querySelector('.fb-hd__drawer');
      if (!this.drawer) return;

      this.openBtn = this.querySelector('[data-fb-drawer-open]');
      this.panel = this.drawer.querySelector('.fb-hd__drawer-panel');

      var self = this;

      if (this.openBtn) {
        this.openBtn.addEventListener('click', function () {
          self.openDrawer();
        });
      }

      this.drawer.querySelectorAll('[data-fb-drawer-close]').forEach(function (btn) {
        btn.addEventListener('click', function () {
          self.closeDrawer();
        });
      });

      // Close naar man klikker et menupunkt
      this.drawer.querySelectorAll('a[href]').forEach(function (a) {
        a.addEventListener('click', function () {
          self.closeDrawer();
        });
      });

      this.onKeydown = function (e) {
        if (e.key === 'Escape' && self.drawer.classList.contains('is-open')) {
          self.closeDrawer();
        }
      };
      document.addEventListener('keydown', this.onKeydown);
    }

    openDrawer() {
      if (!this.drawer) return;
      this.drawer.hidden = false;
      // Tving reflow saa transitionen koerer
      void this.drawer.offsetWidth;
      this.drawer.classList.add('is-open');
      if (this.openBtn) this.openBtn.setAttribute('aria-expanded', 'true');
      document.body.style.overflow = 'hidden';

      var focusTarget = this.drawer.querySelector('.fb-hd__drawer-close');
      if (focusTarget) focusTarget.focus();
    }

    closeDrawer() {
      if (!this.drawer) return;
      this.drawer.classList.remove('is-open');
      if (this.openBtn) {
        this.openBtn.setAttribute('aria-expanded', 'false');
        this.openBtn.focus();
      }
      document.body.style.overflow = '';

      var drawer = this.drawer;
      setTimeout(function () {
        if (!drawer.classList.contains('is-open')) drawer.hidden = true;
      }, 480);
    }

    /* ----------------------------- Carttaeller --------------------------- */
    setupCartCount() {
      var el = this.querySelector('[data-fb-cart-count]');
      if (!el) return;

      // Opdater naar Dawn melder om aendring i kurven
      document.addEventListener('cart:updated', function (e) {
        var count =
          e.detail && e.detail.cart ? e.detail.cart.item_count : null;
        if (count === null) return;
        el.textContent = count;
        el.hidden = count === 0;
      });

      // Fallback: hent kurven efter add-to-cart-formularer
      document.addEventListener('submit', function (e) {
        var form = e.target;
        if (!form || form.getAttribute('action') !== '/cart/add') return;
        setTimeout(function () {
          fetch(window.Shopify && window.Shopify.routes
            ? window.Shopify.routes.root + 'cart.js'
            : '/cart.js')
            .then(function (r) { return r.json(); })
            .then(function (cart) {
              el.textContent = cart.item_count;
              el.hidden = cart.item_count === 0;
            })
            .catch(function () {});
        }, 700);
      });
    }
  }

  customElements.define('fb-header', FbHeader);
})();
